// Tek kaynak: turkiyeDistricts.json (hem frontend import hem server require okur).
// Bölgesel fiyat pipeline normalizasyonu server/lib/util/locationNormalize.js de aynı JSON'u kullanır.
import TURKIYE_CITY_DISTRICT_OPTIONS from './turkiyeDistricts.json';

export { TURKIYE_CITY_DISTRICT_OPTIONS };
export const TURKIYE_CITIES = Object.keys(TURKIYE_CITY_DISTRICT_OPTIONS);
